<template>
    <div class="call">
        <div class="call_title">
            2. Asesoría pedagógica
        </div>
        <div class="call_subtitle">
            Llamada telefónica
        </div>
        <div class="call_description">
            Te llamaremos al <span>número que registraste...</span>
        </div>
        <div class="call_cellphone">
            <span class="material-icons">
            call
            </span>
            <div class="call_cellphone_number" v-if="phone">
                {{ phone }}
            </div>
            <div class="call_cellphone_number" v-else-if="user">
                {{ user.phone }}
            </div>
        </div>

        <!-- <div class="call_alternative_title">
            ... o si lo deseas, puedes indicar otro número
        </div>

        <div class="call_alternative_number">
            <v-text-field
                single-line
                filled
                v-model="phone"
                required
                :error-messages="phoneError"
                @input="$v.phone.$touch()"
                @blur="$v.phone.$touch()"
                @keypress="isPhoneNumber($event)"
            ></v-text-field>

            <div class="call_alternative_saved">
                <span class="material-icons">
                check_circle_outline
                </span>
                Guardado
            </div>
        </div> -->
        <div class="call_footer">
            <v-btn
                color="primary"
                class="uppercase"
                @click="nextStep"
                >
                llámenme ahora
            </v-btn>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      user: null,
      buttonLoading: false,
      phone: ""
    }
  },
  methods: {
    nextStep(){
      this.$emit('completed');
    }
  },
  computed: {

  },
  mounted() {
      this.user = this.$store.state.usuario;
      this.phone = this.$store.state.phone;
    //   console.log(this.user);
  },
}
</script>
